import { Action, createReducer, on } from '@ngrx/store';

import * as AuthenticationActions from './authentication.actions';
import { UserInformation } from './authentication.models';

export const AUTHENTICATION_FEATURE_KEY = 'authentication';

export interface AuthenticationState {
  authenticated: boolean;
  employee: boolean;
  exclude_analytics: boolean;
  sub?: string;
  userInfo?: UserInformation;
}

export interface AuthenticationPartialState {
  readonly [AUTHENTICATION_FEATURE_KEY]: AuthenticationState;
}

export const initialAuthenticationState: AuthenticationState = {
  authenticated: false,
  employee: false,
  exclude_analytics: true,
};

const reducer = createReducer(
  initialAuthenticationState,
  on(AuthenticationActions.changed, (state, action) => ({
    ...state,
    ...(typeof action.authenticated !== 'undefined' && { authenticated: action.authenticated }),
    ...(typeof action.employee !== 'undefined' && { employee: action.employee }),
    ...(typeof action.exclude_analytics !== 'undefined' && { exclude_analytics: action.exclude_analytics }),
    ...(typeof action.sub !== 'undefined' && { sub: action.sub }),
    ...(typeof action.userInfo !== 'undefined' && { userInfo: action.userInfo }),
  }))
);

export function authenticationReducer(state: AuthenticationState | undefined, action: Action) {
  return reducer(state, action);
}
